import { type ApolloError } from '@apollo/client';
import { createContext } from 'react';
import { API } from '@shared/types/api';

export interface WorkflowEntityState {
  workflowEntity: API.WorkflowEntity | null;
  updateField: (field: string, value: any) => Promise<API.WorkflowEntity | undefined>;
  loading: boolean;
  error: ApolloError | undefined;
}

const initialState: WorkflowEntityState = {
  workflowEntity: null,
  updateField: async () => undefined,
  loading: false,
  error: undefined,
};

export const WorkflowEntityContext = createContext(initialState);
